<div class="app__solid--border w-[500px] h-[364px] relative rounded-[10px] bg-white px-[20px] py-[18px]">
  <div class="app__centered-item justify-between">
    <span class="app__form--attribute--title text-xl leading-[30px]">{{ data.headerTitle }}</span>
    <button class="app__centered-item bg-transparent" (click)="closeDialog()">
      <mat-icon class="text-[#25508E] font-bold">close</mat-icon>
    </button>
  </div>

  @if(data.currentFormName && data.suggestedFormName){
  <div class="mt-4" [class]="showNameError ? 'mb-[2px]' : 'mb-5'">
    <span class="app__form--attribute--title font-medium text-[12px] text-[#828282]">Current Name</span>
    <div class="app__centered-item justify-start h-[48px] rounded bg-[#F5F5F5] border-solid border-[1.2px] border-[#B1ACB066] px-3 mt-1">
      <span class="app__form--attribute--title font-medium text-sm text-[#333333]"> {{ data.currentFormName }} </span>
    </div>
    <span class="flex items-center gap-2 mt-2">
      <img src="assets/images/rename_document_star_icon.svg" alt="AI Rename" class="w-4 h-4" />
      <span class="app__form--attribute--title font-medium text-[12px] text-[#828282]">New Name</span>
    </span>
    <input
      class="app__centered-item justify-start w-full h-[48px] rounded bg-white border-solid border-[1.2px] border-[#B1ACB066] px-3 mt-1 app__form--attribute--title font-medium text-sm text-[#333333] outline-none"
      [(ngModel)]="editedFormName"
      (ngModelChange)="showNameError = false"
      (focus)="selectAllContent($event)"
      (keyup.enter)="renameDocumentNameToSuggestedName()"
    />
    @if(showNameError){
    <span class="mt-1 text-xs text-[#D92D20]">Please enter a new name.</span>
    }
  </div>
  }

  <div class="w-full flex" [class]="data?.hasCancelButton ? 'justify-end gap-3' : ''">
    @if(data?.hasCancelButton){
    <button class="app__centered-item bg-transparent gap-2 hover:cursor-pointer" (click)="closeDialog()">
      <span class="app__form--attribute--title text-base font-semibold"> Cancel</span>
    </button>
    }
    <button
      class="app__btn--primary rounded-lg font-semibold text-base py-[12px] sm:py-[12px] sm:text-base m-0 max-[480px]:m-0"
      [class]="data?.hasCancelButton ? 'w-[102px]' : 'w-full'"
      (click)="renameDocumentNameToSuggestedName()"
    >
      {{ data?.buttonName }}
    </button>
  </div>
  @if(data?.dismissLabel){
  <div class="app__centered-item text-center mt-4">
    <span
      class="app__form--attribute--title font-medium text-sm leading-[24px] text-[#25508E] underline hover:cursor-pointer"
      (click)="dismissDocumentNameSuggestion()"
    >
      {{ data.dismissLabel }}
    </span>
  </div>
  }
</div>
